var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({key:_vm.spriteHref,attrs:{"data-testid":`${_vm.name}-illustration`,"role":"presentation","width":_vm.illustrationSize,"height":_vm.illustrationSize}},_vm.$listeners),[_c('use',{attrs:{"href":_vm.spriteHref}})])
}
var staticRenderFns = []

export { render, staticRenderFns }